import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-electrical-signature-analysis',
  templateUrl: './electrical-signature-analysis.component.html',
  styleUrls: ['./electrical-signature-analysis.component.scss']
})
export class ElectricalSignatureAnalysisComponent implements OnInit {
  public company_name: string;
  public assetType: string = "MOTOR";
  
  constructor() {
    this.company_name = localStorage.getItem("company_name");
   }

  ngOnInit(): void {
  }

}
